export default __webpack_public_path__ + "static/media/logoFbhLeanColaboradores.a646c03e.png";